import { DweenColors } from "utils/enums";
import { PriorityInfo, StatusInfo, TableOptions } from "./types";

export const statusType: StatusInfo[] = [
  { value: "TODO", severity: "info", translationKey: "word.to-do", bgColor: DweenColors.Cold },
  { value: "IN_PROGRESS", severity: "warning", translationKey: "word.in-progress", bgColor: DweenColors.PET },
  { value: "DONE", severity: "success", translationKey: "word.done", bgColor: DweenColors.Boiler },
  { value: "CANCELLED", severity: "danger", translationKey: "word.cancelled", bgColor: DweenColors.Heat },
];

export const maintenanceStatuses: StatusInfo[] = [
  { value: "REGISTERED", severity: "info", translationKey: "word.registered", bgColor: DweenColors.Grey500 },
  { value: "COORDINATED", severity: "info", translationKey: "word.coordinated", bgColor: DweenColors.Cold },
  { value: "PLANNED", severity: "info", translationKey: "word.planned", bgColor: DweenColors.Air },
  { value: "IN_PROGRESS", severity: "warning", translationKey: "word.in-progress", bgColor: DweenColors.PET },
  { value: "DONE", severity: "success", translationKey: "word.done", bgColor: DweenColors.Boiler },
  { value: "CANCELLED", severity: "danger", translationKey: "word.cancelled", bgColor: DweenColors.Heat },
  { value: "DELAYED", severity: "warning", translationKey: "word.delayed", bgColor: DweenColors.Dry },
  { value: "EXTENDED", severity: "warning", translationKey: "word.extended", bgColor: DweenColors.Waste },
];

export const priorityType: PriorityInfo[] = [
  { value: "HIGHEST", severity: "red", icon: "pi pi-angle-double-up", translationKey: "word.highest" },
  { value: "HIGH", severity: "red", icon: "pi pi-angle-up", translationKey: "word.high" },
  { value: "MEDIUM", severity: "orange", icon: "pi pi-bars", translationKey: "word.medium" },
  { value: "LOW", severity: "blue", icon: "pi pi-angle-down", translationKey: "word.low" },
  { value: "LOWEST", severity: "blue", icon: "pi pi-angle-double-down", translationKey: "word.lowest" },
]
export const measurementOrder = ["Darbo valandos", "Q", "V", "T1", "T2", "P", "D", "Klaida"];

export const STATUS_UPDATE_TIME = 60 * 1000;

export const DATA_EXPORT_LIMIT = 200;
export const CHUNK_SIZE = 100;

export const ENUM_OPS = ["EQ", "NEQ", "IS_BLANK", "NOT_BLANK"];
export const NUM_OPS = ["EQ", "NEQ", "GT", "GTE", "LT", "LTE"];

export const initialFilter: TableOptions = {
  first: 0,
  rows: 10,
  page: 0,
  sortField: "",
  sortOrder: 1,
  multiSortMeta: [],
  filters: {},
  filter: null,
  andFilters: [],
  search: "",
  reqSortField: "",
};
